<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
    :width="$vuetify.breakpoint.smAndUp ? '85vw' : '100vw'"
  >
    <v-card elevation="5" class="rounded-lg">
      <v-card-title class="primary white--text">
        <span class="text-h5">Surtir OP's</span>
        <v-spacer></v-spacer>
        <v-btn
          color="white"
          class="primary--text"
          @click="showHistoryModal = true"
          icon
        >
          <v-icon>mdi-history</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container fluid class="pa-4">
          <!-- Selección de producto -->
          <v-row>
            <v-col cols="12" md="6">
              <v-combobox
                :items="productsDelivery"
                label="Tipo de producto"
                v-model="product"
                outlined
                dense
                clearable
              ></v-combobox>
            </v-col>

            <!-- Stock MO -->
            <v-col
              cols="12"
              md="6"
              v-if="
                product &&
                (product.value == 'F' || (product.value == 'MO' && moSelected))
              "
            >
              <v-card outlined>
                <v-card-text class="d-flex align-center">
                  <v-btn
                    color="primary"
                    @click="openLoteModal"
                    small
                    class="mr-2"
                  >
                    <v-icon small>mdi-database-eye-outline</v-icon>
                    Stock MO
                  </v-btn>
                  <span class="text-caption">
                    Stock total: <strong>{{ stockQty }}</strong> dosis
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Selección de microorganismo -->
          <v-row v-if="product && product.value == 'MO'">
            <v-col cols="12">
              <v-autocomplete
                label="Microorganismo"
                outlined
                dense
                hide-no-data
                prepend-inner-icon="mdi-bacteria"
                item-text="identificationName"
                no-data-text="No se encontraron microorganismos"
                return-object
                v-model="moSelected"
                :loading="fetchMO"
                :search-input.sync="searchMO"
                :items="identificationsFounded"
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>

          <!-- Selector de fechas -->
          <v-row>
            <v-col cols="12">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dates"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="!product"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedDates"
                    label="Rango de fechas"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    :disabled="!product"
                    @click:clear="dates = []"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dates" range scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="saveDates()"
                    :disabled="dates.length !== 2"
                  >
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-chip v-if="dates.length === 2" color="info" small class="mt-2">
                Total: {{ totalPieces }} pz
              </v-chip>
            </v-col>
          </v-row>

          <!-- Tabla de OPs (reemplaza al autocomplete) -->
          <v-row v-if="dates.length == 2">
            <v-col cols="12">
              <v-card class="elevation-2 mt-4">
                <v-card-title class="d-flex flex-wrap">
                  <span class="text-h6">Órdenes de Producción</span>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchTable"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                    outlined
                    dense
                    class="mt-2 mt-sm-0"
                    style="max-width: 300px"
                  ></v-text-field>
                </v-card-title>

                <v-data-table
                  :value="safeSelectedItems"
                  @input="updateSelectedItems"
                  :headers="opHeaders"
                  :items="safeFilteredProducts"
                  :search="searchTable"
                  :loading="fetchDelivery"
                  loading-text="Cargando órdenes..."
                  no-data-text="No hay órdenes disponibles"
                  item-key="_id"
                  show-select
                  :items-per-page="5"
                  class="elevation-1"
                >
                  <template v-slot:item.serial="{ item }">
                    <v-chip small color="primary" dark>
                      {{ item.serial }}
                    </v-chip>
                  </template>

                  <template v-slot:item.presentation="{ item }">
                    {{ item.presentation.name }}
                  </template>

                  <template v-slot:item.deliveredDate="{ item }">
                    {{ new Date(item.deliveredDate).toLocaleDateString() }}
                  </template>

                  <template v-slot:item.qty="{ item }">
                    <v-chip small> {{ item.qty }} pz </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>

          <!-- Botón de asignar -->
          <v-row v-if="selectedItem && selectedItem.length > 0">
            <v-col cols="12" class="text-right">
              <v-btn
                color="primary"
                @click="openLoteSupplyModal()"
                :disabled="selectedItem.length === 0"
                class="mt-4"
              >
                <v-icon left>mdi-plus</v-icon>
                Asignar ({{ selectedItem.length }})
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-btn
          color="red"
          @click="closeModal()"
          dark
          block
          :disabled="supplyingStock"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Modales -->
    <HistoryModal
      v-model="showHistoryModal"
      v-if="showHistoryModal"
      @fetchData="updateProduct"
    />
    <StockModalMO v-model="showStockModalMO" v-if="showStockModalMO" />
    <SupplyLoteModal
      v-model="showSupplyLoteModal"
      v-if="showSupplyLoteModal"
      @fetchData="updateStock"
      @assigned="cleanDelivery"
    />
  </v-dialog>
</template>

<script>
// components
import HistoryModal from "@/components/dashboard/production-orders/modals/HistoryModal.vue";
import StockModalMO from "@/components/dashboard/lote/modals/StockModalMO.vue";
import SupplyLoteModal from "@/components/dashboard/lote/modals/SupplyLoteModal.vue";
//vuex
import { mapActions, mapMutations } from "vuex";
//axios
import axios from "axios";

export default {
  components: {
    HistoryModal,
    StockModalMO,
    SupplyLoteModal,
  },
  data: () => ({
    deliveries: [],
    products: [],
    searchDelivery: null,
    searchMO: null,
    moSelected: null,
    fetchMO: false,
    fetchDelivery: false,
    identificationsFounded: [],
    selectedItem: [],
    stockQty: 0,
    showHistoryModal: false,
    showStockModalMO: false,
    showSupplyLoteModal: false,
    addingDelivery: false,
    supplyingStock: false,
    product: null,
    productsDelivery: [
      { text: "Ag Boost", value: "F" },
      { text: "Microorganismos", value: "MO" },
      { text: "Kits", value: "KIT" },
    ],
    dates: [],
    menu: false,
    totalPieces: 0,
    searchTable: "",
    opHeaders: [
      { text: "Selección", value: "data-table-select", sortable: false },
      { text: "OP", value: "serial", width: "120px" },
      { text: "Presentación", value: "presentation" },
      { text: "Cantidad", value: "qty", align: "center", width: "100px" },
      { text: "Fecha", value: "deliveredDate", width: "120px" },
    ],
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    formattedDates() {
      if (this.dates.length === 2) {
        return `${this.dates[0]} al ${this.dates[1]}`;
      }
      return this.dates.join(", ");
    },
    safeProducts() {
      return Array.isArray(this.products) ? this.products : [];
    },
    safeDeliveries() {
      return Array.isArray(this.deliveries) ? this.deliveries : [];
    },
    safeFilteredProducts() {
      try {
        return this.safeProducts.filter(
          (item) => !this.safeDeliveries.some((d) => d._id === item._id)
        );
      } catch (error) {
        console.error("Error filtering products:", error);
        return [];
      }
    },
    safeSelectedItems() {
      return Array.isArray(this.selectedItem) ? this.selectedItem : [];
    },
  },
  methods: {
    updateSelectedItems(items) {
      this.selectedItem = Array.isArray(items) ? items : [];
    },
    formatItemText(item) {
      return `${item.serial} / ${item.presentation.name} / ${item.qty} pz / ${item.deliveredDate}`;
    },
    ...mapActions("bioactives", ["searchBioactives"]),
    ...mapActions("order", [
      "getProductOrdersByIdentification",
      "addLoteToProduct",
      "makeSupply",
    ]),
    ...mapActions("lotes", ["getStockByIdentification"]),
    ...mapMutations("lotes", [
      "SET_MO_SELECTED",
      "SET_FETCH_LOTES_LIST",
      "SET_PRODUCTS_SELECTED",
    ]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },
    openLoteModal() {
      this.showStockModalMO = true;
      this.SET_MO_SELECTED(this.moSelected);
    },
    async addDelivery() {
      this.addingDelivery = true;
      if (!this.selectedItem) return;
      let exist = this.deliveries.find(
        (element) => element._id == this.selectedItem._id
      );
      if (!exist) {
        try {
          let auxList = this.deliveries;
          auxList.push(this.selectedItem);
          let payload = {
            products: auxList,
            identification: this.moSelected
              ? this.moSelected.identification
              : null,
            moType: this.moSelected ? this.moSelected.moType : null,
            name: this.moSelected ? this.moSelected.identificationName : null,
            isBio: this.product.value,
          };

          let response = await this.addLoteToProduct(payload);
          if (!response || response.error) throw response;
          this.deliveries = response.products;
          this.selectedItem = null;
          await this.fetchDeliveries();
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al asignar lote!!`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
      this.addingDelivery = false;
    },
    deleteDelivery(index) {
      this.deliveries.splice(index, 1);
    },
    async cleanDelivery() {
      this.SET_PRODUCTS_SELECTED([]);
      this.selectedItem = null;
      this.showSupplyLoteModal = false;
      await this.updateProduct();
    },
    async fetchDeliveries() {
      if (this.product) {
        try {
          let payload = {};

          payload = {
            identification: this.moSelected ? this.moSelected._id : null,
            isBio: this.product.value,
            search: this.searchDelivery,
            dates: this.dates,
          };

          let response = await this.getProductOrdersByIdentification(payload);
          if (response.error) throw response;
          this.products = response.productOps;
        } catch (error) {
          console.log(error);
        }
      }
    },
    saveDates() {
      if (this.dates.length === 2) {
        this.$refs.menu.save(this.dates);
      }
    },
    openLoteSupplyModal() {
      this.SET_PRODUCTS_SELECTED(this.selectedItem);
      this.showSupplyLoteModal = true;
    },
    async updateStock() {
      try {
        if (this.product.value == "F" || this.product.value == "KIT") {
          let payload = {
            isBio: this.product.value,
            dates: this.dates,
          };

          let responseIdentification = await this.getStockByIdentification(
            payload
          );
          if (responseIdentification.error) throw response;

          this.stockQty = responseIdentification.qty;
        } else {
          let responseIdentification = await this.getStockByIdentification({
            identification: this.moSelected.identification,
          });
          if (responseIdentification.error) throw response;

          this.stockQty = responseIdentification.qty;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateProduct() {
      if (this.product) {
        try {
          let payload = {};
          let response, responseIdentification;

          if (this.product.value == "F" || this.product.value == "KIT") {
            this.moSelected = null;
            this.searchMO = null;
            this.selectedItem = null;
            this.stockQty = 0;

            payload = {
              isBio: this.product.value,
              dates: this.dates,
            };

            // Asegurarse de que products siempre sea un array
            response = await this.getProductOrdersByIdentification(payload);
            this.products = Array.isArray(response?.productOps)
              ? response.productOps
              : [];

            responseIdentification = await this.getStockByIdentification(
              payload
            );
            this.totalPieces = response?.total || 0;
            this.stockQty = responseIdentification?.qty || 0;
          } else {
            payload = {
              search: this.searchDelivery,
              identification: this.moSelected?._id,
              dates: this.dates,
            };

            response = await this.getProductOrdersByIdentification(payload);
            this.products = Array.isArray(response?.productOps)
              ? response.productOps
              : [];

            responseIdentification = await this.getStockByIdentification({
              identification: this.moSelected?.identification,
            });
            this.totalPieces = response?.total || 0;
            this.stockQty = responseIdentification?.qty || 0;
          }
        } catch (error) {
          console.error("Error al actualizar productos:", error);
          this.products = []; // Asegurar que products sea array incluso en error
          this.$store.commit("alerts/SET_ALERT", {
            type: "error",
            message: "Error al cargar las órdenes de producción",
          });
        }
      }
    },
  },
  watch: {
    async searchDelivery(val) {
      await this.fetchDeliveries();
    },
    async searchMO(val) {
      if (!val) {
        this.selectedItem = null;
        return;
      } else {
        this.fetchMO = true;

        if (typeof this.cancelToken != typeof undefined) {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }

        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());

        try {
          const response = await this.searchBioactives({
            name: val,
          });
          if (response.error) throw response;

          this.identificationsFounded = response.strains;
        } catch (e) {
          console.log(e);
        }
        this.fetchMO = false;
      }
    },
    async moSelected(val) {
      if (!val) {
        this.searchMO = null;
        this.selectedItem = null;
        this.stockQty = 0;
        this.dates = [];
      } else {
        await this.updateStock();
      }
    },
    async product(value) {
      if (value && (value.value == "F" || value.value == "KIT")) {
        try {
          this.moSelected = null;
          this.searchMO = null;
          this.selectedItem = null;
          this.stockQty = 0;
          let payload = {
            isBio: value.value,
            dates: this.dates,
          };

          let responseIdentification = await this.getStockByIdentification(
            payload
          );
          if (responseIdentification.error) throw response;
          this.stockQty = responseIdentification.qty;
        } catch (error) {
          console.log(error);
        }
      } else {
        this.moSelected = null;
        this.searchMO = null;
        this.selectedItem = null;
        this.stockQty = 0;
        this.dates = [];
      }
    },
    async dates(value) {
      if (!value || value.length != 2) return;
      await this.updateProduct();
    },
  },
};
</script>

<style scoped>
/* Estilos para mejorar la tabla en móviles */
@media (max-width: 600px) {
  .v-data-table >>> .v-data-table-header th,
  .v-data-table >>> .v-data-table__mobile-table-row {
    font-size: 0.8rem;
  }

  .v-data-table >>> .v-data-table__mobile-row {
    min-height: 40px;
  }
}

/* Ajustes para los chips */
.v-chip {
  margin: 2px;
}
</style>